import axiosInstance from "../axios/axiosInstance";
import config from "./Config";

export default class EmpresaService {

    listAllEmpresa(data) {
        return axiosInstance.get(`${config.api.version}/empresa/${data}/get`)
    }

    getEmpresa(data, id) {
        return axiosInstance.get(`${config.api.version}/empresa/${data}/get/${id}`)
    }

    getEmpresaPorCnpj(data, cnpj) {
        return axiosInstance.get(`${config.api.version}/empresa/${data}/get?cnpj=${cnpj}`)
    }

    postEmpresa(data, empresa) {
        return axiosInstance.post(`${config.api.version}/empresa/${data}/`, empresa)
    }

    putEmpresa(data, empresa, id) {
        return axiosInstance.put(`${config.api.version}/empresa/${data}/${id}`, empresa)
    }

    deleteEmpresa(data, id) {
        return axiosInstance.put(`${config.api.version}/empresa/${data}/delete/${id}`)
    }

    activeEmpresa(data, id, status) {
        return axiosInstance.put(`${config.api.version}/empresa/${data}/active/${id}/${status}`)
    }
}